<template>
  <!-- 添加/编辑任务 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="dialogType === 1 ? '添加任务' : '编辑任务'"
      width="630px"
      @close="closeDialog"
    >
      <el-form
        :model="taskForm"
        v-if="taskForm"
        ref="taskForm"
        label-width="80px"
        size="small"
        :rules="taskRules"
      >
        <el-form-item prop="cycle" label="任务类型">
          <el-select v-model="taskForm.cycle" placeholder="请选择任务类型">
            <el-option value="daily" label="普通盲盒"></el-option>
            <el-option value="battle" label="热血盲盒"></el-option>
            <el-option value="upgrade" label="幸运升级"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="behavior" label="任务途径">
          <el-select v-model="taskForm.behavior" placeholder="请选择任务途径">
            <el-option :value="1" label="开箱"></el-option>
            <el-option :value="2" label="充值"></el-option>
            <el-option :value="3" label="对战"></el-option>
            <el-option :value="4" label="升级金额"></el-option>
            <el-option :value="5" label="热血盲盒金额"></el-option>
            <el-option :value="6" label="普通盲盒金额"></el-option>
            <el-option :value="7" label="热血盲盒流水"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="conditions_origin"
          v-if="taskForm.behavior === 1 || taskForm.behavior === 3"
          label="箱子id"
        >
          <!-- 这里的show_box_name只是个代名词显示箱子名字的，真正使用的是conditions_origin箱子id这个字段 -->
          <el-autocomplete
            class="inline-input"
            v-model="show_box_name"
            :fetch-suggestions="querySearch"
            placeholder="请输入箱子id"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item
          prop="conditions_origin"
          v-if="taskForm.behavior === 2"
          label="充值金额"
        >
          <el-input
            style="width: 250px"
            v-model="taskForm.conditions_origin"
            placeholder="请输入充值金额"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="conditions_origin"
          v-if="
            taskForm.behavior == 4 ||
            taskForm.behavior == 5 ||
            taskForm.behavior == 6 ||
            taskForm.behavior == 7
          "
          label="金额"
        >
          <el-input
            style="width: 250px"
            v-model="taskForm.conditions_origin"
            placeholder="请输入金额"
          ></el-input>
        </el-form-item>
        <el-form-item prop="conditions" label="任务次数">
          <el-input
            style="width: 250px"
            v-model="taskForm.conditions"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="reward"
          label="奖励金额"
          v-if="
            taskForm.behavior == 1 ||
            taskForm.behavior == 2 ||
            taskForm.behavior == 3
          "
        >
          <el-input style="width: 250px" v-model="taskForm.reward"></el-input>
        </el-form-item>
        <el-form-item
          prop="task_probabilities"
          label="奖励金额"
          v-if="
            taskForm.behavior == 4 ||
            taskForm.behavior == 5 ||
            taskForm.behavior == 6
          "
        >
          <p
            class="text-line"
            style="margin-bottom: 10px"
            v-for="(item, index) in taskForm.task_probabilities"
            :key="index"
          >
            概率{{ index + 1 }}：
            <el-input
              style="width: 100px"
              v-model="item.probability"
              placeholder="概率"
            ></el-input>
            ——
            <el-input
              style="width: 100px"
              v-model="item.min_amount"
              placeholder="最小金额"
            ></el-input>
            —
            <el-input
              style="width: 100px"
              v-model="item.max_amount"
              placeholder="最大金额"
            ></el-input>
            <i
              v-if="taskForm.task_probabilities.length > 1"
              class="el-icon-remove-outline reduce_btn"
              @click="reduceTextLine(index)"
            ></i>
            <i
              v-if="taskForm.task_probabilities.length - 1 === index"
              class="el-icon-circle-plus-outline add_btn"
              @click="addTextLine"
            ></i>
          </p>
        </el-form-item>
        <el-form-item
          prop="reward_show"
          label="显示金额"
          v-if="
            taskForm.behavior == 4 ||
            taskForm.behavior == 5 ||
            taskForm.behavior == 6
          "
        >
          <el-input
            style="width: 250px"
            v-model="taskForm.reward_show"
            placeholder="请输入显示金额(范围请用 ~ 隔开)"
          ></el-input>
        </el-form-item>
        <el-form-item prop="title" label="任务名称">
          <el-input style="width: 250px" v-model="taskForm.title"></el-input>
        </el-form-item>
        <el-form-item prop="reward_title" label="奖励名称">
          <el-input
            style="width: 250px"
            v-model="taskForm.reward_title"
          ></el-input>
        </el-form-item>
        <el-form-item prop="weight" label="任务权重">
          <el-input style="width: 250px" v-model="taskForm.weight"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '@/http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    typeDialog: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      taskData: undefined,//任务列表
      taskForm: {//任务表单
        cycle: undefined,
        behavior: 1,//任务途径 1开箱 2充值 3对战 4升级金额 5热血盲盒金额 6普通盲盒金额
        conditions: undefined,
        conditions_origin: undefined,
        reward: undefined,//当behavior为1、2、3时,
        task_probabilities: [{ probability: '', min_amount: '', min_amount: '' }],//当behavior为4、5、6时,
        reward_show: '',//前端显示金额
        title: undefined,
        reward_title: undefined,
        weight: undefined,
      },
      taskRules: {//任务表单验证
        cycle: [
          {
            required: true,
            message: '请选择任务类型',
            trigger: 'blur'
          }
        ],
        behavior: [
          {
            required: true,
            message: '请选择任务途径',
            trigger: 'blur'
          }
        ],
        conditions_origin: [
          {
            required: true,
            message: '请输入箱子id/充值金额',
            trigger: 'blur'
          }
        ],
        conditions: [
          {
            required: true,
            message: '请输入任务次数',
            trigger: 'blur'
          }
        ],
        reward: [
          {
            required: true,
            message: '请输入任务奖励金额',
            trigger: 'blur'
          }
        ],
        task_probabilities: [
          {
            required: true,
            message: '请输入奖励金额',
            trigger: 'blur'
          }
        ],
        reward_show: [
          {
            required: true,
            message: '请输入显示金额',
            trigger: 'blur'
          }
        ],
        title: [
          {
            required: true,
            message: '请输入任务完整名称',
            trigger: 'blur'
          }
        ],
        reward_title: [
          {
            required: true,
            message: '请输入任务奖励名称',
            trigger: 'blur'
          }
        ],
        weight: [
          {
            required: true,
            message: '请输入任务权重',
            trigger: 'blur'
          }
        ],

      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    taskInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.typeDialog
      },
      set() {
      }
    },
    show_box_name: {
      get() {
        //是字符串类型保持原有，不是则转化为字符串类型
        return typeof this.taskForm.conditions_origin === 'string' ? this.taskForm.conditions_origin : JSON.stringify(this.taskForm.conditions_origin)
      },
      set(val) {
        if (val) {
          this.taskForm.conditions_origin = val
        } else {
          this.taskForm.conditions_origin = undefined
        }
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val && this.taskInfo) {
        this.taskForm = this.taskInfo
      }

    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.$refs['taskForm'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = this.taskForm

          if (this.dialogType == 1) {
            postApiData('task', params).then(res => {
              this.$message.success('添加成功！')
              this.closeDialog()//关闭弹窗
              this.$emit("refresh")//刷新数据
            }).finally(() => {
              this.buttonLoading = false
            })
          } else if (this.dialogType == 2) {
            patchApiData(`task/${params.id}`, params).then(res => {
              this.$message.success('编辑成功！')
              this.closeDialog()//关闭弹窗
              this.$emit("refresh")//刷新数据
            }).finally(() => {
              this.buttonLoading = false
            })
          }
        }
      })
    },
    querySearch(queryString, cb) {
      // 返回查询的数据
      let params = {
        page: 1,
        name: queryString
      }
      getData('box', params).then((res) => {
        //拿取盒子列表数据
        if (res) {
          var restaurants = res.data
          var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
          for (const item of results) {
            // 必须用value字段装要显示的值
            item.value = item.name
          }
          cb(results);// 调用 callback 返回建议列表的数据
        }
      })
    },
    createFilter(queryString) {
      //模糊查询匹配，字符串是否存在
      return (restaurant) => {
        return (restaurant.name.indexOf(queryString) === 0);
      }
    },
    handleSelect(item) {
      // 选中箱子后，将箱子id赋值给conditions_origin
      this.taskForm.conditions_origin = item.id
      this.taskForm.title = `开箱“${item.name}”`
    },
    addTextLine() {
      //加行
      let params = { probability: '', min_amount: '', min_amount: '' }
      this.taskForm.task_probabilities.push(params)
    },
    reduceTextLine(num) {
      //减行
      this.taskForm.task_probabilities.splice(num, 1)
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
      setTimeout(() => {
        if (this.dialogType == 2) {
          this.taskForm = {//还原任务表单
            cycle: undefined,
            behavior: 1,
            conditions: undefined,
            conditions_origin: undefined,
            reward: undefined,
            task_probabilities: [{ probability: '', min_amount: '', min_amount: '' }],//设置初始数据
            reward_show: '',//前端显示金额
            title: undefined,
            reward_title: undefined,
            weight: undefined,
          }
        }
      }, 500)
    }
  }

}
</script>
<style lang="less" scoped>
</style>